import picture from "@/assets/hero-hall-of-fame.jpg?w=640;960;1280;1536&format=avif;webp;jpg&quality=70&as=picture";
import type { MarketingPicture } from "@/lib/marketing-images";

export const heroHallOfFamePic = picture as MarketingPicture;
